<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">서버 이미지 목록</div>
        <div class="setting-addel">
          <el-button size="mini" @click="openSettingPopup('ADD')"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDeleteButton" :disabled="!checkedRows.length"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="imageTable" :column-default="columnDefault" :data="tableData" :columns="tableColumns" highlight-current-row
      :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total"
      @row-click="onRowClick" @row-dblclick="onRowDblclick" @selection-change="onSelectionChange" @condition-change="loadData">
      <template slot-scope="scope" slot="show-flag-slot">
        <el-switch v-model="scope.row.showFlag" active-value="1" inactive-value="0" :disabled="true" />
      </template>
    </el-table-wrapper>
    <w-server-image-setting-popup ref="settingPopup" :popup-params="popupParams" :os-list="osList" :dbms-list="dbmsList" :was-list="wasList"
    @reload="loadData" />
  </div>
</template>

<script>
import { isEmpty, isNil, isEqual, cloneDeep, filter } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import VirtualServiceSettingAPI from '@/api/settings/virtual/virtual-service-settings';
import WServerImageSettingPopup from '../popup/ServerImageSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WServerImageTable',
  components: {
    WServerImageSettingPopup,
  },
  data() {
    const tableColumns = [
      {
        align: 'center',
        type: 'selection',
      },
      {
        prop: 'showFlag',
        label: '공개',
        headerAlign: 'center',
        width: '60px',
        scopedSlot: 'show-flag-slot',
      },
      // {
      //   prop: 'imageName',
      //   label: '서버 이미지명',
      //   width: 150,
      //   searchable: true,
      //   sortable: true,
      //   remoteProp: 'image_name',
      //   formatter: defaultFormatter,
      // },
      {
        prop: 'osName',
        label: '운영체제',
        width: 180,
        searchable: true,
        sortable: true,
        remoteProp: 'os.sw_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'dbmsName',
        label: 'DBMS',
        width: 180,
        searchable: true,
        sortable: true,
        remoteProp: 'dbms.sw_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'wasName',
        label: 'WAS',
        width: 180,
        searchable: true,
        sortable: true,
        remoteProp: 'was.sw_name',
        formatter: defaultFormatter,
      },
      {
        prop: 'imageDesc',
        label: '이미지 설명',
        searchable: true,
        remoteProp: 'image_desc',
        sortable: true,
        formatter: defaultFormatter,
      },
    ];
    return {
      total: null,
      selectedRow: null,
      popupParams: {},
      tableData: [],
      tableColumns,
      checkedRows: [],
      showSearchTool: false,
      columnDefault,
      osList: [],
      dbmsList: [],
      wasList: [],
    };
  },
  created() {
    VirtualServiceSettingAPI.getVmsImageSwList().then((response) => {
      const result = response.data;
      if (result.success) {
        const imageSwList = result.data;
        this.osList = filter(imageSwList, (item) => isEqual(item.swType, 'OS'));
        this.dbmsList = filter(imageSwList, (item) => isEqual(item.swType, 'DBMS'));
        this.wasList = filter(imageSwList, (item) => isEqual(item.swType, 'WAS'));
      }
    }).catch(() => {
    });
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 서버 이미지 목록 조회
     * @author najongdang
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = this.$refs.imageTable.getParameter();
      VirtualServiceSettingAPI.getVmsImageList(tableParams).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
          this.$nextTick(() => {
            if (this.tableData.length > 0) {
              if (isNil(this.selectedRow)) {
                this.selectedRow = this.tableData[0];
              } else {
                const selectedRow = this.tableData.find((row) => (row.imageId === this.selectedRow.imageId));
                if (isNil(selectedRow)) {
                  this.selectedRow = this.tableData[0];
                }
              }
              const selectedRow = this.tableData.find((row) => (row.imageId === this.selectedRow.imageId));
              this.$refs.imageTable.getTable().setCurrentRow(selectedRow);
              this.onRowClick(selectedRow);
            }
          });
        }
      });
    },
    /**
     * 서버 이미지 삭제
     * @author najongdang
     * @return {[type]} [description]
     */
    onDeleteButton() {
      const action = msgUtil.action.DELETE;
      const messageName = '서버 이미지';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        VirtualServiceSettingAPI.deleteVmsImageList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, messageName, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, messageName, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, messageName, false));
        });
      }).catch(() => {});
    },
    onRowClick(row) {
      this.selectedRow = cloneDeep(row);
      this.$emit('target-change', row);
    },
    /**
     * 테이블 row 더블 클릭
     * @author najongdang
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDblclick(row) {
      this.openSettingPopup('UPDATE', row);
    },
    /**
     * 서버 이미지 추가/수정 팝업 open
     * @author najongdang
     * @param  {[type]} popupType   [description]
     * @param  {[type]} selectedRow [description]
     * @return {[type]}             [description]
     */
    openSettingPopup(popupType, selectedRow) {
      this.popupParams = { popupType };
      if (!isEmpty(selectedRow)) {
        this.popupParams.selectedRow = selectedRow;
      }
      this.$refs.settingPopup.open();
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/components/ServerImageTable.vue